export const STATISTICS_SEARCH_PAGE_SIZE = 15;
